import React from "react";
import { Spin, Flex } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { LoaderProps } from "models/loader";

const contentStyle: React.CSSProperties = {
  padding: 50,
  // background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
  color: "red",
};

const content = <div style={contentStyle} />;

export const Loader: React.FC<LoaderProps> = (props: any) => {
  const { loaderText, wrapperClassName } = props;
  return (
    <Flex gap="middle" justify="center" align="center">
      <Spin
        style={{ color: "red" }}
        tip={loaderText}
        indicator={<LoadingOutlined spin style={{ color: "red" }} />}
        size="large"
        wrapperClassName={wrapperClassName}
      >
        {content}
      </Spin>
    </Flex>
  );
};
